import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import URLs from '../../../../../utils/appURLs';
import axiosInstance from '../../../../../app/config/axiosInstance';

interface SharedTripDetails {
  tripCode: string;
  tripID: string;
  source: string;
  destination: string;
  startTime: string;
  endTime: string;
  vehicleNumber: string;
  driverName: string;
  startLat: number;
  startLng: number;
  endLat: number;
  endLng: number;
  startTimestamp: number;
  endTimestamp: number;
  deviceID: string;
}

interface TripshareViewState {
  data: SharedTripDetails | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: TripshareViewState = {
  data: null,
  isLoading: false,
  error: null
};
//using

export const tripsshareView = createAsyncThunk<any, any>(
  'delivery/trips',
  async ({ tripCode, uuid }) => {
    const response = await axiosInstance({
      method: 'GET',
      url: `${URLs.Trip_Tracking}tripCode=${tripCode}&token=${uuid}`
    });

    console.log(response, 'API Response for tripCode:', tripCode);
    return response.data;
  }
);

const tripshareViewSlice = createSlice({
  name: 'tripshareView',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(tripsshareView.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        tripsshareView.fulfilled,
        (state, action: PayloadAction<SharedTripDetails>) => {
          state.isLoading = false;
          state.data = action.payload;
          state.error = null;
        }
      )
      .addCase(tripsshareView.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch trip details';
      });
  }
});

export const tripshareView = tripshareViewSlice.reducer;
